export default "__VITE_ASSET__BYh1YACd__"